import { configureStore } from "@reduxjs/toolkit";
import useSlice from "./userSlice";
import drawerSlice from "./drawerSlice";
import commcercialInvoiceSlice from "./commericalInvoiceSlice";
import batchTicket from "./batchTicketSlice";
import dataFromBE from "./dataFromBESlice";
import fuelBatchTicket from "./fuelBatchTicketSlice";
import layoutSlide from "./layoutSlide";
import filterSlice from "./filterSlice";
const store = configureStore({
  reducer: {
    user: useSlice,
    drawer: drawerSlice,
    commercialinvoice: commcercialInvoiceSlice,
    batchTicket: batchTicket,
    data: dataFromBE,
    fuelBatchTicket: fuelBatchTicket,
    layout: layoutSlide,
    filter: filterSlice,
  },
});

export default store;
